import { Article } from '../articlesData';

export const articleGaeldsbrevLaaneaftaleMitid: Article = {
  id: 'gaeldsbrev-laaneaftale-mitid-skabelon',
  slug: 'gaeldsbrev-laaneaftale-mitid-skabelon',
  title: 'Gældsbrev skabelon: Opret et juridisk gyldigt lån med MitID-signering',
  subtitle: 'Komplet guide til låneaftaler og gældsbreve mellem virksomheder, familiemedlemmer eller anpartshavere. Lær kravene til tvangsfuldbyrdelse og digital underskrift.',
  metaTitle: 'Gældsbrev Skabelon med MitID: Juridisk Gyldig | KvikSign',
  metaDescription: 'Gratis gældsbrev skabelon med MitID-signering. Sikr dit udlån juridisk, opfyld retsplejelovens krav om tvangsfuldbyrdelse og undgå skattefælder.',
  canonicalUrl: 'https://kviksign.com/da/articles/gaeldsbrev-laaneaftale-mitid-skabelon',
  heroImage: 'https://firebasestorage.googleapis.com/v0/b/kviksign-db-europe/o/Website%2FPhotos%2FHome%20private.webp?alt=media&token=702d0942-2935-43b0-907d-7dca99624d8a',
  heroImageAlt: 'Gældsbrev og låneaftale underskrevet med digital signatur og MitID',
  category: 'Finans & Jura',
  author: {
    name: 'KvikSign',
    role: 'eID & Sikkerhedsteam',
    avatar: '/icon.svg'
  },
  publishedAt: '2026-10-14',
  updatedAt: '2026-10-14',
  readingTime: '6 min læsetid',
  keywords: [
    'gældsbrev skabelon mitid',
    'låneaftale skabelon gratis',
    'anfordringslån gældsbrev',
    'tvangsfuldbyrdelsesklausul gældsbrev',
    'lån mellem virksomheder kontrakt',
    'anpartshaverlån gældsbrev',
    'digital signatur gældsbrev',
    'familielån rentefrit kontrakt'
  ],
  keyTakeaways: [
    'Et gældsbrev er en skriftlig, ubetinget erklæring om at skylde et bestemt beløb og er långiverens primære bevis i tilfælde af manglende tilbagebetaling.',
    'For at et gældsbrev kan sendes direkte i Fogedretten uden en forudgående langvarig retssag, skal dokumentet indeholde en eksplicit tvangsfuldbyrdelsesklausul (§ 478 i Retsplejeloven).',
    'Digitale underskrifter med MitID opfylder beviskravene til fulde og eliminerer debitorers påstande om, at de aldrig har underskrevet dokumentet.',
    'Ved lån mellem et selskab og dets kapitalejere (anpartshaverlån) gælder særlige regler i selskabsloven og skattelovgivningen for at undgå beskatning som løn eller udbytte.',
    'KvikSign sikrer, at både debitor og kreditor modtager en krypteret, forseglet PDF med digitalt tidsstempel, der kan fremvises i retten eller for Skattestyrelsen.'
  ],
  tableOfContents: [
    { id: 'hvad-er-et-gaeldsbrev-og-hvorfor-er-det-noedvendigt', title: 'Hvad er et gældsbrev, og hvorfor er det nødvendigt?' },
    { id: 'forskellen-paa-anfordringslaan-og-afdragslaan', title: 'Forskellen på anfordringslån og afdragslån' },
    { id: 'retsplejelovens-krav-til-tvangsfuldbyrdelse-fogedretten', title: 'Retsplejelovens krav til tvangsfuldbyrdelse (Fogedretten)' },
    { id: 'anpartshaverlaan-og-koncernlaan-pas-paa-skattefaelderne', title: 'Anpartshaverlån: Pas på skattefælderne' },
    { id: 'fordele-ved-mitid-signering-af-gaeldsbreve', title: 'Fordele ved MitID-signering af gældsbreve' },
    { id: 'download-gratis-gaeldsbrev-skabelon', title: 'Download gratis gældsbrev-skabelon' },
    { id: 'faq-gaeldsbrev', title: 'Ofte stillede spørgsmål om gældsbreve' }
  ],
  sections: [
    {
      id: 'hvad-er-et-gaeldsbrev-og-hvorfor-er-det-noedvendigt',
      title: 'Hvad er et gældsbrev, og hvorfor er det nødvendigt?',
      paragraphs: [
        'Uanset om du låner penge ud til en forretningspartner, et datterselskab eller et familiemedlem, er en mundtlig aftale eller en simpel bankoverførsel utilstrækkelig.',
        'Uden et skriftligt gældsbrev kan skyldneren påstå, at pengene var en gave, et honorar for en opgave eller et indskud. Skattestyrelsen kan desuden anse uforklarlige pengeoverførsler for skattepligtig indkomst eller gave, medmindre der foreligger et dateret gældsbrev.',
        'Et juridisk gældsbrev fastslår hovedstolen, eventuel forrentning, afdragsordning og forfaldsdato.'
      ]
    },
    {
      id: 'forskellen-paa-anfordringslaan-og-afdragslaan',
      title: 'Forskellen på anfordringslån og afdragslån',
      paragraphs: [
        'Der findes grundlæggende to typer gældsbreve:',
        '1. Anfordringslån: Långiveren kan til enhver tid kræve hele beløbet indfriet med et kort varsel (f.eks. 14 dage). Denne type er særligt udbredt ved rentefrie familielån for at undgå gavebeskatning.',
        '2. Lån med fast afdragsordning: Her aftales en fast månedlig eller kvartalsvis ydelse, en fastsat rentefod samt hvad der sker i tilfælde af misligholdelse.'
      ]
    },
    {
      id: 'retsplejelovens-krav-til-tvangsfuldbyrdelse-fogedretten',
      title: 'Retsplejelovens krav til tvangsfuldbyrdelse (Fogedretten)',
      paragraphs: [
        'Et af de vigtigste elementer i et professionelt gældsbrev er tvangsfuldbyrdelsesklausulen i henhold til Retsplejelovens § 478, stk. 1, nr. 5.',
        'Uden denne klausul skal kreditor først anlægge en langvarig og dyr civil retssag for at få en dom over skyldneren. Med en korrekt formuleret klausul og debitors verificerede underskrift kan gældsbrevet overdrages direkte til Fogedretten med henblik på udlæg i skyldnerens aktiver.'
      ]
    },
    {
      id: 'anpartshaverlaan-og-koncernlaan-pas-paa-skattefaelderne',
      title: 'Anpartshaverlån: Pas på skattefælderne',
      paragraphs: [
        'Udlån fra et kapitalselskab til en kapitalejer (aktionærlån) er underlagt strenge særregler i Selskabsloven og Ligningsloven.',
        'Selskabet skal have tilstrækkelige frie reserver, og lånet skal forrentes på markedsvilkår for at undgå øjeblikkelig beskatning som maskeret udbytte. Et præcist formuleret gældsbrev underskrevet med MitID er revisorens og Skattestyrelsens krav til godkendt dokumentation.'
      ]
    },
    {
      id: 'fordele-ved-mitid-signering-af-gaeldsbreve',
      title: 'Fordele ved MitID-signering af gældsbreve',
      paragraphs: [
        '• Uafviselig datering: Ingen kan påstå, at dokumentet er oprettet med tilbagevirkende kraft (antidateret).',
        '• Ingen uenighed om underskriften: MitID knytter debitors CPR- eller CVR-nummer uløseligt til dokumentet.',
        '• Øjeblikkelig håndtering: Långiver og låntager kan underskrive med få minutters mellemrum, hvorefter lånet sikkert kan udbetales.'
      ]
    },
    {
      id: 'download-gratis-gaeldsbrev-skabelon',
      title: 'Download gratis gældsbrev-skabelon',
      paragraphs: [
        'Hent vores kvalitetssikrede skabelon til gældsbrev med lovpligtig tvangsfuldbyrdelsesklausul, forrentningsregler og klare afdragsbetingelser.'
      ]
    }
  ],
  faqs: [
    {
      question: 'Kan et gældsbrev underskrives digitalt og stadig være gyldigt i Fogedretten?',
      answer: 'Ja. Fogedretten accepterer gældsbreve med digital signatur, så længe dokumentet er forsynet med en verificerbar Avanceret Elektronisk Signatur (som MitID) og indeholder Retsplejelovens § 478-klausul.'
    },
    {
      question: 'Må et familielån være rentefrit?',
      answer: 'Ja, et familielån kan oprettes som et rentefrit anfordringslån uden skattemæssige konsekvenser, såfremt långiver på anfordring kan kræve lånet indfriet.'
    },
    {
      question: 'Hvor længe er et gældsbrev gyldigt?',
      answer: 'Ifølge forældelsesloven forældes et almindeligt gældsbrev efter 10 år (mod normalt 3 år for simple fakturakrav), medmindre gælden erkendes eller forældelsen afbrydes.'
    }
  ],
  sources: [
    { title: 'Retsplejeloven § 478 (Retsinformation)', url: 'https://www.retsinformation.dk' },
    { title: 'Skattestyrelsen - Udlån og familielån regler', url: 'https://skat.dk' }
  ],
  disclaimer: 'Oplysningerne heri er vejledende og erstatter ikke juridisk eller skattemæssig rådgivning. Ved større beløb eller lån i selskaber bør revisor eller advokat inddrages.'
};
